// USER_CLICKED actions
export const CLICK_SIGN_OUT_ALL_SESSIONS = 'acct/user/click_sign_out_all_sessions';

// SYSTEM_action_process actions
export const SYSTEM_EMAIL_VERIFY_FAIL = 'acct/system/verify_email_fail';
export const SIGN_OUT_ALL_SESSIONS = 'acct/system/sign_out_all_sessions';
export const SESSIONS_DATA_EMPTY = 'acct/system/sessions_data_empty';
